import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountDetailsLayoutComponent } from './account-details-layout.component';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { UpdateAccountVisitsModule } from '../../user-history/update-account-visits/update-account-visits.module';
import { SharedModule } from '../../shared/shared.module';
import { LetDirective } from '@ngrx/component';
import { ScopeCaptionPipe } from '../../shared/pipes/scope-caption.pipe';
import { AccountVisibilityService } from '../account-visibility.service';
import { NgxPermissionsModule } from 'ngx-permissions';
import { GetAccountChildrenModule } from '../get-account-children/get-account-children.module';

@NgModule({
  imports: [
    CommonModule,
    NgbNavModule,
    RouterModule,
    UpdateAccountVisitsModule,
    SharedModule,
    LetDirective,
    ScopeCaptionPipe,
    NgxPermissionsModule,
    GetAccountChildrenModule,
    AccountDetailsLayoutComponent,
  ],
  providers: [ AccountVisibilityService ],
})
export class AccountDetailsLayoutModule {
}
